import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import HomePage2 from "../HomePage2/HomePage2";
import EmployeeLogin from "../EmployeeLogin/EmployeeLogin.js";
import AboutUsPage from "../AboutUsPage/AboutUsPage";
import PricingPage from "../PricingPage/PricingPage";
import PortfolioPage from "../PortfolioPage/PortfolioPage";
import PortfolioSinglePage from "../PortfolioSinglePage/PortfolioSinglePage";
import TeamSinglePage from "../TeamSinglePage/TeamSinglePage";
import ServicePage from "../ServicePage/ServicePage";
import ServiceSinglePage from "../ServiceSinglePage/ServiceSinglePage";
import BlogPage from "../BlogPage/BlogPage";
import BlogDetails from "../BlogDetails/BlogDetails";
import ContactPage from "../ContactPage/ContactPage";
import CareerPage from "../Careers/CareerPage";
import Login from "../Login/Login.js";
import Dashboard from "../Dashboard/Dashboard";
import PostJob from "../Dashboard/Postjob";
import ContactDF from "../ContactFormData/ContactDF";
import NewsLetterEmail from "../newsLetterEmail/NewsLetterEmail";
import ApplyJob from "../Dashboard/ApplyJob";
import { AuthProvider, ProtectedRoute } from "../Login/AuthContext";
import ManageJob from "../Dashboard/ManageJob";
import ManageApplications from "../Dashboard/ManageApplications";
import PostBlog from "../Dashboard/postBlog";
import { HelmetProvider } from "react-helmet-async";
import SEO from "../../components/SEO";
import GenerateEmployee from "../Dashboard/GenerateEmployee.js";
import GetEmployee from "../Dashboard/GetEmployee.js";
import EmployeeDashboard from "../EmployeeDashboard/EmployeeDashboard.js";
import PDFViewer from "../PDFViewer.js";
import BlogManagement from "../Dashboard/BlogManagement";
import BlogDetail from "../../components/BlogDetail";
import BlogList from "../../components/BlogList";

import SubscribersList from "../Dashboard/SubscribersList";

// Import TaskDashboard with correct path (removed wrong prefix)
import TaskDashboard from "../TaskDashboard/TaskDashboard";

// Import NEW AdminEmployeeManagement
import AdminEmployeeManagement from "../AdminEmployeeManagement";
import AdminAttendanceManagement from "../AdminAttendanceManagement.js";
import EmployeeAttendance from "../../components/EmployeeAttendance/EmployeeAttendance.js";
// Remove duplicate ProtectedRoute import - use only from AuthContext
// import ProtectedRoute from './main-component/Login/ProtectedRoute'; // REMOVED

// import SubscribersList from "../Dashboard/SubscribersList";
import PrivacyPolicy from "../PrivacyPolicy/PrivacyPolicy.jsx";
import Texora from "../Texora/Texora.js";
import FaqPage from "../FaqPage/Faq.js";
import TestimonialPage from "../TestimonialPage/Testimonial.js";
import DigitalMarketing from "../DigitalMarketing/DigitalMarketing.js";
import ContactCenterDesign from "../ContactCenterDesign/ContactCenterDesign.js";
import HRConsulting from "../HRConsultingPage/HRConsulting.js";
import TaskOrbit from "../TaskOrbit/TaskOrbit.js";
 import LoginTabs from "../MultiLogins/Logins.js";
 import Bot from "../UnifiedBot/Bot.js";
 import CustomerExperience from "../CustomerExperience/CustomerExperience.js";



const AllRoute = () => {
  return (
    <HelmetProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<HomePage2 />} />
              <Route path="home" element={<HomePage2 />} />
              <Route path="about" element={<AboutUsPage />} />
              <Route path="/view-resume/:key" element={<PDFViewer />} />
              <Route path="employeeLogin" element={<EmployeeLogin />} />
              <Route path="employeeDashboard" element={<EmployeeDashboard />} />
              <Route path="pricing" element={<PricingPage />} />
              <Route path="portfolio" element={<PortfolioPage />} />
              <Route path="/admin/subscribers" element={<SubscribersList />} />
              <Route
                path="portfolio_details/:slug"
                element={<PortfolioSinglePage />}
              />
              <Route path="team-single/:slug" element={<TeamSinglePage />} />
              <Route path="service" element={<ServicePage />} />
              <Route
                path="service-single/:slug"
                element={<ServiceSinglePage />}
              />

              {/* ✅ FIXED Blog Routes - Specific routes first */}
              <Route path="blog" element={<BlogPage />} />
              <Route path="blog-single/:slug" element={<BlogDetails />} />
              <Route path="blogs" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="blog-management" element={<BlogManagement />} />

              <Route path="contact" element={<ContactPage />} />
              <Route path="career" element={<CareerPage />} />
              <Route path="login" element={<Login />} />
              {/* Updated to use job slug in URL */}
              <Route path="apply/:slug" element={<ApplyJob />} />
              <Route path="/admin/subscribers" element={<SubscribersList />} />

              {/* Admin routes */}
              <Route
                path="/attendance-management"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <AdminAttendanceManagement />
                  </ProtectedRoute>
                }
              />

              {/* Employee routes */}
              <Route
                path="/my-attendance"
                element={
                  <ProtectedRoute>
                    <EmployeeAttendance />
                  </ProtectedRoute>
                }
              />

              {/* Protected Routes */}
              <Route
                path="dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="dashboard/contact-data"
                element={
                  <ProtectedRoute>
                    <ContactDF />
                  </ProtectedRoute>
                }
              />
              <Route
                path="dashboard/newsletter-data"
                element={
                  <ProtectedRoute>
                    <NewsLetterEmail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="dashboard/post-job"
                element={
                  <ProtectedRoute>
                    <PostJob />
                  </ProtectedRoute>
                }
              />

              {/* NEW ROUTE - Employee Management */}
              <Route
                path="dashboard/employee-management"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <AdminEmployeeManagement />
                  </ProtectedRoute>
                }
              />

              <Route
                path="dashboard/generate-employee"
                element={
                  <ProtectedRoute>
                    <GenerateEmployee />
                  </ProtectedRoute>
                }
              />
              <Route
                path="dashboard/manage-jobs"
                element={
                  <ProtectedRoute>
                    <ManageJob />
                  </ProtectedRoute>
                }
              />
              <Route
                path="dashboard/check-job-applications"
                element={
                  <ProtectedRoute>
                    <ManageApplications />
                  </ProtectedRoute>
                }
              />
              <Route
                path="dashboard/getAllEmployee"
                element={
                  <ProtectedRoute>
                    <GetEmployee />
                  </ProtectedRoute>
                }
              />
              <Route
                path="dashboard/post-blog"
                element={
                  <ProtectedRoute>
                    <PostBlog />
                  </ProtectedRoute>
                }
              />

              {/* Task Management Routes */}
              <Route
                path="/admin/task-dashboard"
                element={
                  <ProtectedRoute>
                    <TaskDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/task-dashboard"
                element={
                  <ProtectedRoute>
                    <TaskDashboard />
                  </ProtectedRoute>
                }
              />

              {/* Privacy Policy Route */}
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/texora" element={<Texora />} />
              <Route path="/taskorbit" element={<TaskOrbit />} />
              <Route path="/logins" element={<LoginTabs />} />
              <Route path="/unifiedbot" element={<Bot />} />
              <Route path="/customer-experience" element={<CustomerExperience />} />
              <Route path="/faq" element={<FaqPage/>}></Route>
              <Route path="/testimonial" element={<TestimonialPage/>}></Route>
              <Route path="/digital-marketing" element={<DigitalMarketing/>}></Route>
              <Route path="/hr-consulting" element={<HRConsulting/>}></Route>
              <Route path="/contact-center-designing" element={< ContactCenterDesign/>}></Route>
     
            </Routes>
          </BrowserRouter>
        </div>
      </AuthProvider>
    </HelmetProvider>
  );
};

export default AllRoute;
